import { Select } from "@closer/ui";
import { useState } from "react";
import { Outlet, useNavigate } from "react-router";

import { useAuth } from "../lib/authContext";

export function AppLayout() {
  const { user, memberships, activeTenantId, activeTenant, setActiveTenant, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  async function handleLogout() {
    await logout();
    navigate("/login");
  }

  return (
    <div className="flex min-h-screen bg-slate-50">
      <aside className="flex w-60 shrink-0 flex-col border-r border-slate-200 bg-white">
        <div className="border-b border-slate-200 px-4 py-4 text-base font-semibold text-slate-900">
          Closer
        </div>
        {/* Menü boş: ürün modülleri kendi Jira kartlarıyla eklenecek. */}
        <nav className="flex flex-1 flex-col gap-1 p-2" aria-label="Ana gezinme" />
      </aside>
      <div className="flex min-w-0 flex-1 flex-col">
        <header className="flex h-14 items-center justify-between border-b border-slate-200 bg-white px-4">
          <p className="truncate text-sm font-medium text-slate-900">{activeTenant?.name ?? ""}</p>
          <div className="flex items-center gap-3">
            <Select
              aria-label="Firma değiştir"
              value={activeTenantId ?? ""}
              onChange={(event) => setActiveTenant(event.target.value)}
              className="w-48"
            >
              {memberships.map((membership) => (
                <option key={membership.tenantId} value={membership.tenantId}>
                  {membership.name}
                </option>
              ))}
            </Select>
            <div className="relative">
              <button
                type="button"
                onClick={() => setMenuOpen((prev) => !prev)}
                aria-haspopup="menu"
                aria-expanded={menuOpen}
                className="rounded-md px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100"
              >
                {user?.name}
              </button>
              {menuOpen ? (
                <div className="absolute right-0 z-10 mt-1 w-40 rounded-md border border-slate-200 bg-white py-1 shadow-md">
                  <button
                    type="button"
                    onClick={() => void handleLogout()}
                    className="block w-full px-3 py-2 text-left text-sm text-slate-700 hover:bg-slate-100"
                  >
                    Çıkış
                  </button>
                </div>
              ) : null}
            </div>
          </div>
        </header>
        <main className="min-w-0 flex-1 p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
